import type { GoLiveChecksScreenGroup, GoLiveChecksStepId } from './GoLiveChecks.types';

/**
 * The Go Live Checks telemetry category, shared by the intro (fired from every publish surface,
 * guest site included) and the editor's wizard. In `@shared` so the intro can report under the same
 * category without importing admin code.
 */
export const GO_LIVE_CHECKS_TELEMETRY_CATEGORY = 'admin.goLiveChecks';

/**
 * Every check, grouped by how visible its problem is to a guest, in walk order. In `@shared` so the
 * intro lists checks in the wizard's order.
 */
export const GO_LIVE_CHECKS_STEP_GROUPS: ReadonlyArray<GoLiveChecksScreenGroup> = [
  // Template photos and starter copy sit on every page a guest opens.
  { id: 'guestsSee', steps: ['defaultPhotos', 'defaultPageContent'] },
  // An active banner is the first thing a guest reads. A screen of its own: under the photo rows it
  // sat below the fold, where couples walked past it.
  { id: 'announcement', steps: ['banner'] },
  // What the couple pastes into the invitation: the link, its preview, and the password behind it.
  { id: 'shareLink', steps: ['eventUrl', 'linkPreview', 'password'] },
  { id: 'explorePages', steps: ['hiddenPages'] },
  // The one check that applies to every event, so it closes the walk as a final confirmation.
  { id: 'findSite', steps: ['searchPrivacy'] },
];

export const GO_LIVE_CHECKS_STEP_ORDER: ReadonlyArray<GoLiveChecksStepId> = GO_LIVE_CHECKS_STEP_GROUPS.flatMap(group => group.steps);
